import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync, faArrowDown } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer } from 'react-toastify';
import './MovimientosData.css';
import baseURL from '../../url';
import * as XLSX from 'xlsx';

export default function MovimientosData() {
    const [movimientos, setMovimientos] = useState([]);
    const [articulos, setArticulos] = useState([]);
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [tipoMovimiento, setTipoMovimiento] = useState('');
    const [idArticulo, setIdArticulo] = useState('');

    useEffect(() => {
        cargarMovimientos();
        cargarArticulos();
    }, []);

    const cargarArticulos = () => {
        fetch(`${baseURL}/inventarioArticulosGet.php`)
            .then(response => response.json())
            .then(data => setArticulos(data.articulos || []))
            .catch(error => console.error('Error:', error));
    };

    const cargarMovimientos = () => {
        let url = `${baseURL}/inventarioMovimientosGet.php?`;
        const params = [];

        if (fechaInicio) params.push(`fechaInicio=${fechaInicio}`);
        if (fechaFin) params.push(`fechaFin=${fechaFin}`);
        if (tipoMovimiento) params.push(`tipoMovimiento=${tipoMovimiento}`);
        if (idArticulo) params.push(`idArticulo=${idArticulo}`);

        url += params.join('&');

        fetch(url)
            .then(response => response.json())
            .then(data => setMovimientos(data.movimientos || []))
            .catch(error => console.error('Error:', error));
    };

    const limpiarFiltros = () => {
        setFechaInicio('');
        setFechaFin('');
        setTipoMovimiento('');
        setIdArticulo('');
    };

    const descargarExcel = () => {
        const data = movimientos.map(item => ({
            Fecha: new Date(item.fecha).toLocaleString(),
            Artículo: item.nombreArticulo,
            Código: item.codigoArticulo,
            Movimiento: item.tipoMovimiento.toUpperCase(),
            Cantidad: item.cantidad,
            Unidad: item.simboloUnidad,
            Motivo: item.motivo,
            Referencia: item.referencia
        }));

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Movimientos');
        XLSX.writeFile(wb, 'movimientos_inventario.xlsx');
    };

    useEffect(() => {
        cargarMovimientos();
    }, [fechaInicio, fechaFin, tipoMovimiento, idArticulo]);

    return (
        <div>
            <ToastContainer />

            <div className='deFlexContent' style={{ display: 'flex' }}>
                <div className='deFlex2'>
                    <button className='excel' onClick={descargarExcel}>
                        <FontAwesomeIcon icon={faArrowDown} /> Excel
                    </button>
                    <button className='pdf' onClick={limpiarFiltros}>
                        Limpiar Filtros
                    </button>
                </div>

                <div className='filtrosContain'>
                    <div className='inputsColumn'>
                        <label>Fecha Inicio</label>
                        <input
                            type="date"
                            value={fechaInicio}
                            onChange={(e) => setFechaInicio(e.target.value)}
                        />
                    </div>
                    <div className='inputsColumn'>
                        <label>Fecha Fin</label>
                        <input
                            type="date"
                            value={fechaFin}
                            onChange={(e) => setFechaFin(e.target.value)}
                        />
                    </div>
                    <div className='inputsColumn'>
                        <label>Tipo</label>
                        <select value={tipoMovimiento} onChange={(e) => setTipoMovimiento(e.target.value)}>
                            <option value="">Todos</option>
                            <option value="entrada">Entrada</option>
                            <option value="salida">Salida</option>
                        </select>
                    </div>
                    <div className='inputsColumn'>
                        <label>Artículo</label>
                        <select value={idArticulo} onChange={(e) => setIdArticulo(e.target.value)}>
                            <option value="">Todos</option>
                            {articulos.map(art => (
                                <option key={art.idArticulo} value={art.idArticulo}>
                                    {art.nombre}
                                </option>
                            ))}
                        </select>
                    </div>
                    
                </div>
            </div>

            <div className='table-container'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>Fecha</th>
                            <th>Artículo</th>
                            <th>Movimiento</th>
                            <th>Cantidad</th>
                            <th>Unidad</th>
                            <th>Motivo</th>
                            <th>Referencia</th>
                        </tr>
                    </thead>
                    <tbody>
                        {movimientos.map((item, index) => (
                            <tr key={index}>
                                <td>{new Date(item.fecha).toLocaleString()}</td>
                                <td>
                                    {item.nombreArticulo}
                                    {item.codigoArticulo && <span style={{ color: '#888' }}> ({item.codigoArticulo})</span>}
                                </td>
                                <td>
                                    <span className={`badge ${item.tipoMovimiento}`}>
                                        {item.tipoMovimiento.toUpperCase()}
                                    </span>
                                </td>
                                <td>{item.cantidad}</td>
                                <td>{item.simboloUnidad}</td>
                                <td>{item.motivo || '-'}</td>
                                <td>{item.referencia || '-'}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}





